module.exports = __webpack_public_path__ + "static/media/SegoeUI-Bold.c68a8abc.woff";